const SourceTypes = {
  CRM_MANAGED: "crm",
  MANUALLY_CREATED: "manual"
};

SourceTypes.ALL = Object.values(SourceTypes);

export default SourceTypes;
